import en from './translation/lang_en';
import es from './translation/lang_es';
import getCookie from './getCookie';

function format (str, params) {
	let formattedStr = str;
	for (let i = 0; i < params.length; i += 1) {
		const regexp = new RegExp(`\\{${i}\\}`, 'gi');
		formattedStr = formattedStr.replace(regexp, params[i]);
	}
	return formattedStr;
}

export default function translate (key, ...params) {
	const lang = getCookie('lang');

	let translation = `!!! ${key} !!!`;
	if (en[key] !== undefined) {
		translation = en[key];
	}

	if (lang === 'es' && es[key] !== undefined) {
		translation = es[key];
	}

	if (params.length) {
		translation = format(translation, params);
	}
	return translation;
}



// WEBPACK FOOTER //
// ./src/main/webapp/media/scripts/webpack/funcs/translation.js